// actions.js  
/* ------------------- action creators ------------------ */

import Axios from "axios";

export const fetchData = () => {
  return async (dispatch, getState) => {  
    // dispatch({ type: "FETCH_POSTS_REQUEST" });
    try {
      const response = await Axios.get(
        "https://shachi.app/data"
      );
      
      console.log('response.data', response.data)

      dispatch({ type: "FETCH_POSTS_SUCCESS", payload: response.data });
    } catch (error) {
      dispatch({ type: "Fetch_POSTS_FAILURE", error });
    }
  };
};

export const fetchSample = () => {
  return async (dispatch, getState) => {  
    // dispatch({ type: "FETCH_POSTS_REQUEST" });
    try {
      const response = await Axios.get(
        "https://shachi.app/data2"
      );

      console.log('response.data', response.data)

/*
   fetch('https://shachi.app/data2')
            .then(response => response.json())
            .then(data => console.log('x2', data.message))

*/
      dispatch({ type: "FETCH_SAMPLE_SUCCESS", payload: response.data });
    } catch (error) {
      dispatch({ type: "Fetch_SAMPLE_FAILURE", error });
    }
  };
};